var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('data-table',{attrs:{"headers":_vm.headers,"promise":_vm.historicos,"disablePagination":true,"noElevation":true},scopedSlots:_vm._u([{key:"top",fn:function(){return undefined},proxy:true},{key:"item.dataChamada",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("date")(item.dataChamada))+" - "+_vm._s(_vm._f("timeFromNow")(item.dataChamada))+" ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.setStatusAtendimento(item.status))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }